import AddIcon from '@mui/icons-material/Add';

function PlusIcon({ onClickHandler, disabled = false, title = 'View moisture correction summary' }) {
    const handleClick = (event) => {
        if (disabled) return;
        event.preventDefault();
        event.stopPropagation();
        onClickHandler?.(event);
    };

    return (
        <AddIcon
            role="button"
            tabIndex={disabled ? -1 : 0}
            aria-label={title}
            aria-disabled={disabled}
            titleAccess={title}
            onClick={handleClick}
            onKeyDown={(event) => {
                if (disabled) return;
                if (event.key === 'Enter' || event.key === ' ') {
                    handleClick(event);
                }
            }}
            sx={{
                cursor: disabled ? 'not-allowed' : 'pointer',
                color: 'white',
                fontSize: '24px',
                backgroundColor: disabled ? 'grey.500' : 'primary.dark',
                opacity: disabled ? 0.55 : 1,
                margin: '8px 3px 3px 3px',
                padding: '2px',
                borderRadius: '15px',
            }}
        />
    );
}

export default PlusIcon;
